import { render, staticRenderFns } from "./CookieAlert.vue?vue&type=template&id=77ef2528"
import script from "./CookieAlert.vue?vue&type=script&lang=js"
export * from "./CookieAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports